<template>
  <div class="app">
    <component :is="currentView">
      <!-- 非活动组件将被缓存！ -->
    </component>
    <menu class="tab tab-menu">
      <li
        class="tab-item"
        @click="activateView('Home')"
        :class="{ active: currentViewName == 'Home' }"
      >
        <nav class="icon icon-home"></nav>
        <nav class="f-small">诊疗服务</nav>
      </li>
      <li
        class="tab-item"
        @click="activateView('OutMap')"
        :class="{ active: currentViewName == 'OutMap' }"
      >
        <nav class="icon icon-msg"></nav>
        <nav class="f-small">来院导航</nav>
      </li>
      <li
        class="tab-item"
        @click="activateView('Profile')"
        :class="{ active: currentViewName == 'Profile' }"
      >
        <nav class="icon icon-me"></nav>
        <nav class="f-small">个人中心</nav>
      </li>
    </menu>
  </div>
</template>
<script>
import Home from '../home/Home'
import OutMap from '../map/OutMap'
import Profile from '../profile/Profile'

const config = {
  Home,
  OutMap,
  Profile,
}
export default {
  components: {
  },
  beforeMount () {
    const pushUrl = localStorage.getItem('pushUrl')
    if (pushUrl) {
      this.$router.push(pushUrl)
      localStorage.removeItem('pushUrl');
    } else {
      this.$store.commit('clearParam', 'all');
    }
  },
  /* eslint-disable */
  mounted () {

  },
  methods: {
    activateView (viewName) {
      // 来院导航Tab当做菜单来特殊处理
      if (viewName === 'OutMap') {
        //默认进入科室选择
        window.localStorage.tabId = "0";
        this.$store.commit('updateParam', {
          namespace: 'menu',
          url: 'outMap'
        });
        sessionStorage.setItem('areaType', '1')
        sessionStorage.setItem('busiType', '1')
        this.$router.push("HospitalSelect");
        return
      }
      this.$store.commit('changeState', viewName)
    },
  },
  computed: {
    currentView () {
      const viewName = this.$store.state.stateModule.tabActive
      return config[viewName]
    },
    currentViewName () {
      return this.$store.state.stateModule.tabActive
    },
  },
}
</script>
<style lang="scss">
@import "../../../static/sass/_variable.scss";
.tab {
  @include display-flex();
  .tab-item {
    text-align: center;
    @include flex(1);
  }
}

.tab-menu {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 52px;
  border-top: 1px solid #eee;
  padding-top: 10px;
  background: #fff;
  li {
    &.active {
      color: #25be98;
    }
  }
  .icon {
    width: 25px;
    height: 25px;
    margin: auto auto 3px;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .icon-home {
    background-image: url("../../../static/img/nav_menu.png");
    background-position-x: 0;
  }
  .icon-msg {
    background-image: url("../../../static/img/nav_menu.png");
    background-position-x: -50px;
  }
  .icon-me {
    background-image: url("../../../static/img/nav_menu.png");
    background-position-x: -100px;
  }
  .active {
    .icon-home {
      background-image: url("../../../static/img/nav_menu.png");
      background-position-x: -25px;
    }
    .icon-msg {
      background-image: url("../../../static/img/nav_menu.png");
      background-position-x: -75px;
    }
    .icon-me {
      background-image: url("../../../static/img/nav_menu.png");
      background-position-x: -125px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Index.vue?4f3874b3